import { io, type Socket } from 'socket.io-client';
import type { ClientToServerEvents, ServerToClientEvents } from '@livequiz/shared';

export type LiveSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

export function createSocket(): LiveSocket {
  return io({ path: '/socket.io/', autoConnect: true, transports: ['websocket', 'polling'], withCredentials: true });
}
